import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './styles.css';

interface IBannerProps {
  image: string;
  hitUrl: string;
  disclaimer?: string;
}

export function Banner({ disclaimer, image, hitUrl }: IBannerProps) {
  return (
    <a data-testid="banner" href={hitUrl} className={styles['container']} target="_blank" rel="noopener noreferrer">
      <div className={styles['content']}>
        <Image src={image} borderRadius={0} width={1100} />
      </div>
      {disclaimer && (
        <div data-testid="banner-disclaimer" className={styles['disclaimer']}>
          {disclaimer}
        </div>
      )}
    </a>
  );
}
